import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from '../../helpers/date';
import ReactDOMServer from 'react-dom/server';
import QuoteRequestService from 'services/quote-request';

import styles from './style.module.scss';

const ReportsError = () => {
	const defaultFilters = { search: '', per_page: 10, page: 1, current_page: 0, status: "" };
	const [filters, setFilters] = useState(defaultFilters);
	const [leads, setLeads] = useState([]);
	const [pagination, setPagination] = useState({
		current_page: 0,
		from: 0,
		last_page: 0,
		path: "",
		per_page: 0,
		to: 0,
		total: 0
	});
	const [isExporting, setIsExporting] = useState(false)

	useEffect(() => {
		getLeads();
	}, [filters]);

	const getLeads = () => {
		QuoteRequestService.getReportLogError({ params: { ...filters } })
			.then(({ data }) => {
				const { data: response } = data;
				setLeads(mountData(response));
				setPagination(paginationObj(data));
			});
	}

	const mountData = (data) => {
		let arrayLeads = data.map((lead) => {
			return {
				id: lead.id,
				hubspot_id: lead.hubspot_id,
				contact_id: lead.contact_id,
				message: lead.message,
				created_at: parseDateBR(lead.created_at),
			}
		});

		return arrayLeads
	}

	const paginationObj = data => {
		return {
			current_page: data.current_page,
			from: data.from,
			last_page: data.last_page,
			path: "",
			per_page: data.per_page,
			to: data.to,
			total: data.total
		}
	}

	const handleFilterChange = (new_filters, reset = false) => {
		let f = { ...filters, ...new_filters };

		if (reset) f = { ...defaultFilters, ...new_filters };

		setFilters(f);
	};

	const handlePageChange = page => handleFilterChange({ page });


	const columns = [
		{
			dataField: 'hubspot_id',
			text: 'ID Hubspot',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'contact_id',
			text: 'ID Contato',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'message',
			text: 'Mensagem',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
		{
			dataField: 'created_at',
			text: 'Data',
			headerStyle: {
				textAlign: 'center'
			},
			style: {
				textAlign: 'center'
			}
		},
	];

	return (
		<Container fluid>
			<Row>
				<Col>
					<Card>
						<Card.Body>
							<Row>
								<Col xs={6} className="align-self-center">
									<h4 className={styles.headerTitle}>
										Relatório de Erros
									</h4>
								</Col>
							</Row>
							<Row>
								<Col>
									<hr className={styles.line} />
								</Col>
							</Row>
							<Row>
								<Col xs={2} className="d-flex justify-content-start">
									<Form.Group>
										<Form.Label>Registros por página:</Form.Label>
										<Form.Control
											as="select"
											value={filters.per_page}
											onChange={e =>
												handleFilterChange({ per_page: e.target.value, page: 1 })
											}
										>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
											<option value={100}>100</option>
										</Form.Control>
									</Form.Group>
								</Col>
								<Col xs={3} className="d-flex align-items-center">
									<Form.Label>{''}</Form.Label>
									<Button
										variant="primary"
										className="font-12"
										disabled={isExporting}
										onClick={async () => {
											setIsExporting(true)
											QuoteRequestService.getReportLogError({ params: { ...filters, is_export: true } })
												.then(({ data }) => {
													const { data: response } = data
													const errors = mountData(response)
													var a = document.createElement("a")
													var data_type = "data:application/vnd.ms-excel; charset=UTF-8"
													var table_div = (<>
														<BootstrapTable 
															style={{width:'100px'}} 
															keyField="hubspot_id" 
															data={errors} 
															columns={columns} 
														/>
													</>)

													var table_html = escape(ReactDOMServer.renderToString(table_div))
													a.href = data_type + ', ' + table_html;
													a.download = 'Relatorio-Erros.xls';
													a.click();
													setIsExporting(false)
												});
										}}
									>
										Exportar {isExporting ? <Spinner animation="border" /> : (<></>)}
									</Button>
								</Col>
								<Col xs={{ offset: 2 }}></Col>
								{/* <Col xs={3}>
									<Form.Group>
										<Form.Label>Status:</Form.Label>
										<Form.Control
											as="select"
											value={filters.hubspot_status_id}
											onChange={e =>
												handleFilterChange({ hubspot_status_id: e.target.value, page: 1 })
											}
										>
											<option value={""} selected>Selecione o Status</option>
											<option value={1}>Ganho</option>
											<option value={2}>Perdido</option>
											<option value={3}>Assignado</option>
											<option value={4}>Em Negociação</option>
											<option value={5}>Esperando Feedback</option>
										</Form.Control>
									</Form.Group>
								</Col> */}
								<Col xs={3} className="d-flex justify-content-end">
									<Form.Group>
										<Form.Label>Busca:</Form.Label>
										<Form.Control
											onChange={e =>
												handleFilterChange({ search: e.target.value })
											}
											value={filters.search}
										>
										</Form.Control>
									</Form.Group>
								</Col>
							</Row>
							<BootstrapTable
								id="table"
								keyField="id"
								data={leads}
								columns={columns}
							/>
							<Row>
								<Col>
									<Trans i18nKey="label:interpolateShowingRecords">
										Showing {{ from: pagination.from || '0' }} to{' '}
										{{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
										records
									</Trans>
								</Col>
								<Col className="d-flex justify-content-end">
									<Pagination
										activePage={pagination.current_page}
										itemsCountPerPage={pagination.per_page}
										totalItemsCount={pagination.total}
										onChange={handlePageChange}
										pageRangeDisplayed={5}
										itemClass="page-item"
										linkClass="page-link"
										prevPageText="‹"
										nextPageText="›"
									/>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}


export default MasterPage(ReportsError);